import { useQuery } from '@tanstack/react-query';
import { RENTAL_HISTORY_QUERY_KEY } from '../../../shared/constants';
import {
  getRentalHistoryByCompanyChainId,
  getRentalHistoryById,
} from '../services/rentalHistory';
import { format } from 'date-fns';
import { RentalHistorySourceType } from '../../../shared/types/pricingSheets';

export function useRentalHistory(
  rentalHistorySource: RentalHistorySourceType = RentalHistorySourceType.Customer,
  id: string,
  startDate: Date,
  endDate: Date,
  enabled: boolean,
) {
  const queryKey = [RENTAL_HISTORY_QUERY_KEY];
  const formatDate = (d: Date) => {
    return format(d, 'yyyy-MM-dd');
  };

  const queryId = RentalHistorySourceType.Customer
    ? 'CUSTOMER-' + id
    : 'COMPANY_CHAIN-' + id;

  const queryResult = useQuery({
    queryKey: [queryKey, queryId],
    queryFn: () => {
      switch (rentalHistorySource) {
        case RentalHistorySourceType.Customer:
          return getRentalHistoryById(
            id,
            formatDate(startDate),
            formatDate(endDate),
          );
        case RentalHistorySourceType.CompanyChain:
          return getRentalHistoryByCompanyChainId(
            id,
            formatDate(startDate),
            formatDate(endDate),
          );
      }
    },
    staleTime: Infinity, // TODO dont retry if 404
    retry: false,
    enabled: enabled,
  });

  return queryResult;
}
